export function getCDNImageURL(
  imageID: string,
  variant: string = "public"
): string {
  // takes an image ID and returns the url for the image
  return `https://imagedelivery.net/7Ze32-hXUdrEDVtqvlbDMQ/${imageID}/${variant}`;
}
